<template>
  <div
    class="banner-ad"
    :class="bannerColor"
  >
    <div class="close-icon">
      <i
        class="hi hi-close hi-10"
        @click="
          $emit('close');
          !secondaryCta.asDismiss && $emit('dismiss-promotion', 'banner_ad', { dismissed_item: product });
        "
      ></i>
    </div>

    <div class="content">
      <div class="text">
        <img
          class="logo"
          :src="logoSrc"
          :class="logo"
          alt="logo"
        />
        {{ message.text }}
      </div>
      <div class="ctas">
        <template v-if="secondaryCta.asDismiss">
          <a
            class="secondary-cta"
            @click.prevent="
              $emit('close');
              $emit('dismiss-promotion', 'banner_ad', { dismissed_item: product });
            "
          >
            Don't show again
          </a>
        </template>
        <template v-else>
          <a
            class="secondary-cta"
            target="_blank"
            rel="noopener noreferrer"
            :href="secondaryCta.url"
          >
            {{ secondaryCta.text }}
          </a>
        </template>

        <a
          :href="primaryCta.url"
          class="btn btn-primary btn-sm primary-cta"
          @click="$emit('cta-clicked')"
        >
          {{ primaryCta.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { BANNER_AD_LOGOS } from '~/app_constants';
export default {
  name: 'AppBannerAd',
  props: {
    product: {
      type: String,
      required: true,
    },
    message: {
      type: Object,
      default: () => ({}),
    },
    logo: {
      type: String,
      default: 'default',
    },
    bannerColor: {
      type: String,
      default: 'default',
      validator(bannerColor) {
        return ['blue', 'purple', 'default'].includes(bannerColor);
      },
    },
    primaryCta: {
      type: Object,
      required: true,
    },
    secondaryCta: {
      type: Object,
      required: true,
    },
    analyticsInfo: {
      type: Object,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    logoSrc() {
      return BANNER_AD_LOGOS[this.logo];
    },
  },
};
</script>
